import { IconType } from '../../models/notification.model';
import { AnalyticsEvent, AnalyticsService } from 'src/app/core/services/analytics-service';
import { Router } from '@angular/router';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { HandsetService } from '../../../core/services/handset.service';
import { Notification, NotificationStatus } from '../../models/notification.model';
import { NotificationStoreService } from '../../services/notification.service';
import { take } from 'rxjs/operators';

@Component({
standalone: false,
  selector: 'app-notifications-container-row',
  styleUrls: ['./notifications-container-row.component.scss'],
  templateUrl: './notifications-container-row.component.html',
})
export class NotificationsContainerRowComponent {
  @Input() notification: Notification;
  @Output() public handleClose = new EventEmitter<void>();

  public NotificationStatus = NotificationStatus;
  public IconType = IconType;

  constructor(
    public handsetService: HandsetService,
    private router: Router,
    private analyticsService: AnalyticsService,
    private notificationService: NotificationStoreService,
  ) {
  }

  public notificationClicked($event: Event) {
    $event.stopPropagation();
    this.analyticsService.trackEvent(
      new AnalyticsEvent('Notification clicked', { id: this.notification.notificationId }),
    );
    if (this.notification.ctaAction !== null) {
      this.router.navigateByUrl(this.notification.ctaAction).finally(() => {
        this.markAsReadIfNeeded();
        this.handleClose.next();
      });
    } else {
      this.markAsReadIfNeeded();
      this.handleClose.next();
    }
  }

  public markAsReadIfNeeded() {
    if (this.notification.status === NotificationStatus.UNREAD) {
      this.notificationService
        .changeReadStatus(this.notification.notificationId, NotificationStatus.READ)
        .pipe(take(1))
        .subscribe();
    }
  }

  public getId(): string {
    return this.notification.notificationId;
  }
}
